(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bluno-collection"] && !Shopify.designMode) return;
  try {
    
function blunoFilterCollection() {
  const categorySelect = document.getElementById('BlunoCatalogCategory');
  const stockSelect = document.getElementById('BlunoCatalogStock');
  if (!categorySelect || !stockSelect || categorySelect.dataset.initialized) return;
  categorySelect.dataset.initialized = 'true';
  const params = new URLSearchParams(window.location.search);
  stockSelect.value = params.get('stock') || '';
  function navigateCategory(option) {
    if (!option || !option.dataset.url) return;
    const url = new URL(option.dataset.url, window.location.origin);
    ['preview_theme_id', 'country', 'locale'].forEach(key => {
      if (params.has(key)) url.searchParams.set(key, params.get(key));
    });
    if (stockSelect.value) url.searchParams.set('stock', stockSelect.value);
    window.location.assign(url.toString());
  }
  const legacyCategory = params.get('category');
  if (legacyCategory !== null && legacyCategory !== categorySelect.value) {
    const option = Array.from(categorySelect.options).find(item => item.value === legacyCategory);
    if (option) { navigateCategory(option); return; }
  }
  function applyStockFilter() {
    let visible = 0;
    document.querySelectorAll('.bluno-catalog-grid [data-bluno-category]').forEach(card => {
      const hidden = Boolean(stockSelect.value && card.dataset.blunoAvailable !== 'true');
      card.hidden = hidden;
      const parent = card.parentElement;
      if (parent && parent.parentElement && parent.parentElement.classList.contains('bluno-catalog-grid')) parent.hidden = hidden;
      if (!hidden) visible++;
    });
    const empty = document.querySelector('.bluno-catalog-empty');
    if (empty) empty.hidden = visible > 0;
  }
  categorySelect.addEventListener('change', () => navigateCategory(categorySelect.selectedOptions[0]));
  stockSelect.addEventListener('change', () => {
    const url = new URL(window.location.href);
    if (stockSelect.value) url.searchParams.set('stock', stockSelect.value);
    else url.searchParams.delete('stock');
    window.history.replaceState({}, '', url);
    applyStockFilter();
  });
  applyStockFilter();
}
blunoFilterCollection();
document.addEventListener('shopify:section:load', blunoFilterCollection);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
